import { Alert, Box, Button, Dialog, DialogContent, DialogTitle, Grid, Snackbar, Stack, TextField, Typography } from '@mui/material';
import React, { useState } from 'react'
import { UrlApi } from '../../../../services/apirest';

function EdicionClientePredeterminado(props) {
  const [editar, setEditar] = useState(props.editar)
     const [datosRow, setDatosRow] = useState(props.datosRow)
     const [openSnack, setOpenSnack] = React.useState(false);
     const [colormensaje, setColorMensaje] = useState("");
     const [mensaje, setMensaje] = useState("");
     const [disBtn, setDisBtn] = useState(false)
     //Snackbar Notificacion
     const handleCloseSnack = (event, reason) => {
       if (reason === "clickaway") {
         return;
       }
       setOpenSnack(false);
       handleClose()
     };
 
     const handleClose = () => {
         setEditar(!editar);
       if (props.onClose) {
         props.onClose();
       }
     };
 
     const almacenar = (e) => {
         setDatosRow({
           ...datosRow,
           [e.target.name]: e.target.value,
         });
       };
 
       const EditarMotivo = async (e) => {
        setDisBtn(true)
           
           e.preventDefault();
           await fetch(UrlApi + "/envasado_sisven_predeterminados/" + datosRow.id, {
             method: "PUT",
             headers: { "Content-Type": "application/json" },
             body: JSON.stringify({
               sisven_id: datosRow.sisven_id,
             }),
           })
             .then((res) => {
               if (!res.err) {
                 setOpenSnack(true);
                 // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
                 setColorMensaje("#D4EFDF");
                 setMensaje("El motivo se editó exitosamente !");
                 console.log("Guardado");
               } else {
                 setOpenSnack(false);
                 setColorMensaje("#F1948A");
                 setMensaje("Error al editar el motivo");
                 console.log("Error");
               }
             })
             .catch((err) => {
               console.log(err.message);
             });
         };

    return (
     <>
     <Dialog
         fullWidth
         open={editar}
         onClose={() => handleClose()}
         maxWidth="sm"
       >
      <Box justifyContent="center" backgroundColor="#1F618D">
           <DialogTitle>
             <Typography fontSize={20} align="center" color="#ffffff">
               Editar Cliente predeterminado {datosRow.id}
             </Typography>
           </DialogTitle>
         </Box>
         <form autoComplete="off" onSubmit={EditarMotivo}>
         <DialogContent>
             {/* <Box
               backgroundColor="#F4F6F6"
               px={2}
               py={2}
               border={0.5}
               borderColor={"#ABB2B9"}
               borderRadius={3}
             > */}
               <Grid container  spacing={1}>
                <Grid item xs={12} py={1} mb={1}>
                 <TextField
                     label="Sucursal"
                     name="nombre_sucursal"
                     size="small"
                     multiline
                     disabled
                     placeholder="..."
                     inputProps={{
                       maxLength: 50,
                     }}
                     focused
                     required
                     fullWidth
                     value={datosRow.nombre_sucursal}
                    //  onChange={almacenar}
                   />
                 </Grid>
                 
                 <Grid item xs={12} py={1} mb={1}>
                 <TextField
                     label="Sisven ID"
                     name="sisven_id"
                     size="small"
                     multiline
                     placeholder="..."
                     inputProps={{
                       maxLength: 50,
                     }}
                     focused
                     required
                     fullWidth
                     value={datosRow.sisven_id}
                     onChange={almacenar}
                   />
                 </Grid>
                 
               </Grid>
               <Grid container direction="row" justifyContent="space-between" mt={1}>
                 <Grid item>
                   <Button
                     color="error"
                     variant="outlined"
                     onClick={() => handleClose()}
                     style={{ backgroundColor: "#fff" }}
                   >
                     Volver
                   </Button>
                 </Grid>
                 <Grid item>
                   <Button
                     type="submit"
                     color="success"
                     variant="contained"
                     disabled={disBtn}
                   >
                     Guardar
                   </Button>
                 </Grid>
               </Grid>
            {/* </Box> */}
         </DialogContent>
             </form>
     </Dialog>
 
     <Stack spacing={2} sx={{ width: "100%" }}>
         <Snackbar
           open={openSnack}
           autoHideDuration={1500}
           onClose={handleCloseSnack}
           anchorOrigin={{ vertical: "top", horizontal: "center" }}
         >
           <Alert
             onClose={handleCloseSnack}
             severity="success"
             sx={{ width: "100%" }}
             style={{ backgroundColor: colormensaje, color: "black" }}
           >
             {mensaje}
           </Alert>
         </Snackbar>
       </Stack>
   </>
  )
}

export default EdicionClientePredeterminado